import React, { useContext, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router";
import { ModalComponent } from "../../../Components/Modal";
import routes from "../../../Helpers/Routes.json";
import { Context } from "../../../Shared/Context/GlobalContext";
import { useTranslation } from "react-i18next";
import { BiStore } from "react-icons/bi";

export const CashExternalButtonComponent = ({
  id,
  description,
  name,
  shippingMethod,
  deliveryAt,
  validateOrder,
  cartProducts,
  user,
  comments,
  couponCode,
  shippingAddress,
}) => {
  const navigate = useNavigate();
  const { resetCart } = useContext(Context);
  const [submited, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  function handleSubmit() {
    setLoading(true);
    fetch(process.env.REACT_APP_API_HOST + "/api/payment", {
      method: "post",
      headers: { "X-Customer-Token": user.access_token },
      body: JSON.stringify({
        products: cartProducts,
        payment_method: String(id),
        shipping_method: shippingMethod,
        coupon_code: couponCode,
        delivery_at: deliveryAt,
        comments: comments,
        shipping_address: shippingAddress,
      }),
    })
      .then((res) => {
        if (res.status === 200) return res.json();
        throw new Error("Something went wrong");
      })
      .then(({ data }) => {
        setSubmitted(false);
        setLoading(false);
        resetCart();
        navigate(
          routes.Payment.success.replace(":transaction", data.transaction)
        );
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }

  return (
    <>
      <Button
        variant="outline-dark"
        size="lg"
        className="w-100 rounded-pill py-3 mt-2 d-flex align-items-center justify-content-center gap-2"
        title={description}
        onClick={() => {
          const validationResult = validateOrder();
          switch (validationResult) {
            case "missing_shipping_method":
              alert(t("Falta seleccionar forma de entrega"));
              return;
            case "missing_shipping_delivery_at":
              alert(t("Selecciona una fecha de entrega"));
              return;
            case "missing_shipping_address":
              alert(t("Selecciona una dirección de envío"));
              return;
            default:
              setSubmitted(true);
          }
        }}
      >
        <BiStore size={22} />
        {name}
      </Button>

      <ModalComponent
        show={submited}
        setShow={setSubmitted}
        title={t("Pagar en tienda")}
      >
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" className="mb-3" />
            <p className="text-muted mb-0">{t("Procesando pedido...")}</p>
          </div>
        ) : (
          <>
            <p className="mb-3">
              {t("Si decides pagar en tienda te reservaremos el pedido durante 2 días. Si durante este tiempo no tenemos noticias, lo cancelaremos.")}
            </p>
            <p className="fw-bold mb-3">{t("¿Quieres continuar?")}</p>
            <div className="d-flex gap-2">
              <Button
                variant="dark"
                className="w-50 rounded-pill"
                onClick={handleSubmit}
              >
                {t("Sí")}
              </Button>
              <Button
                variant="outline-secondary"
                className="w-50 rounded-pill"
                onClick={() => setSubmitted(false)}
              >
                {t("No")}
              </Button>
            </div>
          </>
        )}
      </ModalComponent>
    </>
  );
};
